const range = require('lodash/range');
const includes = require('lodash/includes');

const moment = require('moment');
const autobind = require('@ordergroove/brandy/src/utils/auto-bind');

const inject = ['ogsdk.Payment'];

function factory(Payment) {
  const ExpirationDate = Payment.ExpirationDate;

  class ExpirationDateController {
    constructor() {
      this.expYears = range(11).map(n => moment().add(n, 'years').year());

      this.expMonths = range(1, 13);
    }

    $onInit() {
      const today = moment();

      // moment months are 0 based.
      this.month = this.model.month || today.month() + 1;
      this.year = this.model.year || today.year();

      if (!includes(this.expYears, this.year)) {
        this.expYears.unshift(this.year);
      }

      this.ngModel.$render = () => {
        this.updateModel(this.month, this.year);
      };
    }

    updateModel(month, year) {
      const  expirationDate = new ExpirationDate(month, year);
      this.ngModel.$setViewValue(expirationDate);
    }
  }

  return autobind(new ExpirationDateController());
}

factory.$inject = inject;

angular.module('msi.payments.form.expiration-date')
  .controller('ExpirationDateController', factory);

module.exports = factory;
